import {
  LoginApi,
  UserApi,
  UserProgressApi,
  StudyApi,
  RoomApi,
} from '@/openapi/user/';

import ApiUtility from '@/classes/common/ApiUtility';




export default class UserApiUtility extends ApiUtility {

  /** APIの基本パス（継承先でこれを変更すれば他のAPIにアクセスできる想定） */
  protected static readonly apiBasePath = '/msapi/user/v1';

  /** 認証/認可トークンキー */
  protected static readonly tokenKey = 'msusertoken';

  /** クッキートークンのパス（空文字以外なら設定する） */
  protected static readonly cookieTokenPath: string = '/msapi/user';

  /** トークン保存をローカルストレージにするか否か */
  protected static readonly isTokenStoredInLocalStorage: boolean = true;




  /**
   * openapi-generatorで生成したログインAPI通信用クラスを取得します
   *
   * @returns
   */
  public static getLoginApi(): LoginApi {
    return new LoginApi(undefined, this.apiBasePath, this.getInstance(false));
  }

  /**
   * openapi-generatorで生成した教室APIクラスを取得します
   *
   * @returns
   */
  public static getRoomApi(): RoomApi {
    return new RoomApi(undefined, this.apiBasePath, this.getInstance(false));
  }

  /**
   * openapi-generatorで生成したユーザーAPIクラスを取得します
   *
   * @returns
   */
  public static getUserApi(): UserApi {
    return new UserApi(undefined, this.apiBasePath, this.getInstance());
  }

  /**
   * openapi-generatorで生成した学習者進度APIクラスを取得します
   *
   * @returns
   */
  public static getUserProgressApi(): UserProgressApi {
    return new UserProgressApi(undefined, this.apiBasePath, this.getInstance());
  }

  /**
   * openapi-generatorで生成した学習APIクラスを取得します
   *
   * @returns
   */
  public static getStudyApi(): StudyApi {
    return new StudyApi(undefined, this.apiBasePath, this.getInstance());
  }

}
